import 'angular';
import 'angular-animate';
import 'angular-messages';
import 'angular-sanitize';
import 'angular-ui-router';
import 'angular-foundation-6';
import 'ng-file-upload';
import 'auth0-js';
import 'angular-auth0';
import 'angular-jwt';
import 'ui-select';
import 'angular-password';
import 'angular-moment-picker';
import 'angular-ui-switch';
import 'angular-flatpickr/dist/ng-flatpickr-comp.js';

export const vendor = [
  'ui.router',
  'ngAnimate',
  'ngSanitize',
  'ngMessages',
  'mm.foundation',
  'ngFileUpload',
  'angular-jwt',
  'auth0.auth0',
  'ui.select',
  'ngPassword',
  'moment-picker',
  'uiSwitch',
];



// WEBPACK FOOTER //
// ./frontend/admin/vendor.js